import {defineMessages} from "@project/i18n";

export const offerTemplateItemMessages = defineMessages({
  editContent: {
    id: "sales.offerTemplates.item.editContent",
    defaultMessage: "Edit content",
    description: "Open the current editor; standalone editor relocation is deferred",
  },
  retryRead: {
    id: "sales.offerTemplates.item.retryRead",
    defaultMessage: "Retry",
    description: "Retry a failed public read without replaying a write",
  },
  byId: {
    id: "sales.offerTemplates.item.byId",
    defaultMessage: "Template {offerTemplateId}",
    description: "Dynamic identity fallback without fabricated name",
  },
  overviewActions: {
    id: "sales.offerTemplates.item.overviewActions",
    defaultMessage: "Template actions",
    description: "Overview actions menu",
  },
  overview: {
    id: "sales.offerTemplates.item.overview",
    defaultMessage: "Overview",
    description: "Read-only item overview",
  },
  details: {
    id: "sales.offerTemplates.item.details",
    defaultMessage: "Details",
    description: "Item state and supported lifecycle",
  },
  editor: {
    id: "sales.offerTemplates.item.editor",
    defaultMessage: "Editor",
    description: "Authored content workspace",
  },
  preview: {
    id: "sales.offerTemplates.item.preview",
    defaultMessage: "Preview",
    description: "Admitted Template source preview",
  },
  loading: {
    id: "sales.offerTemplates.item.loading",
    defaultMessage: "Loading current Template…",
    description: "Current identity/read pending",
  },
  failed: {
    id: "sales.offerTemplates.item.failed",
    defaultMessage: "The current Template read is unavailable. Refresh before changing it.",
    description: "Resource or actor read withdrawal",
  },
  refresh: {
    id: "sales.offerTemplates.item.refresh",
    defaultMessage: "Refresh current reads",
    description: "Public read retry without write replay",
  },
  delete: {
    id: "sales.offerTemplates.item.delete",
    defaultMessage: "Delete Template",
    description: "Soft-delete ACTIVE Template",
  },
  restore: {
    id: "sales.offerTemplates.item.restore",
    defaultMessage: "Restore Template",
    description: "Restore DELETED Template",
  },
  deleteHelp: {
    id: "sales.offerTemplates.item.deleteHelp",
    defaultMessage:
      "Delete this Template? Existing Customer Offers remain unchanged. Template content and Notes remain readable as history.",
    description: "Truthful soft-delete confirmation",
  },
  restoreHelp: {
    id: "sales.offerTemplates.item.restoreHelp",
    defaultMessage: "Restore this Template with its existing identity, authored content and Notes?",
    description: "Truthful restore confirmation",
  },
  cancel: {
    id: "sales.offerTemplates.item.cancel",
    defaultMessage: "Cancel",
    description: "Dismiss unsubmitted lifecycle intent",
  },
  failedWrite: {
    id: "sales.offerTemplates.item.failedWrite",
    defaultMessage:
      "The change failed or current input changed. Refresh and review before trying again.",
    description: "Current unaccepted lifecycle failure",
  },
  accepted: {
    id: "sales.offerTemplates.item.accepted",
    defaultMessage: "Change accepted. Waiting for its current read; do not repeat the write.",
    description: "Actual204 acknowledgement with read lag",
  },
  readOnly: {
    id: "sales.offerTemplates.item.readOnly",
    defaultMessage:
      "Deleted Template history is read-only. Restore is the only lifecycle change available here.",
    description: "History capabilities without commercial actions",
  },
  sourceOnly: {
    id: "sales.offerTemplates.item.sourceOnly",
    defaultMessage:
      "Saved Template source preview. No Expedient-dependent commercial totals are calculated here.",
    description: "Template evaluation boundary",
  },
});
